const META_SELECTOR = 'meta[name="public-company"]';

// Call at render time, not module scope.
export function publicCompany(lowercase = false): string {
    const name = typeof document === 'undefined'
        ? undefined
        : document.querySelector<HTMLMetaElement>(META_SELECTOR)?.content;
    if (name) {
        return name;
    }
    return lowercase ? 'artcloud' : 'ArtCloud';
}

export function rebrandForEveryone(): boolean {
    return typeof document !== 'undefined' && document.querySelector(META_SELECTOR) !== null;
}
